import { render, staticRenderFns } from "./target_index_s.vue?vue&type=template&id=e2274e7e&scoped=true"
import script from "./target_index_s.vue?vue&type=script&lang=js"
export * from "./target_index_s.vue?vue&type=script&lang=js"
import style0 from "./target_index_s.vue?vue&type=style&index=0&id=e2274e7e&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2274e7e",
  null
  
)

export default component.exports